import React from 'react';
import { Link } from 'gatsby';

export default function ReapitBook({ children, type, className }) {
  return (
    <Link
      to="/contact/property-valuation/"
      className={`reapit-val-btn ${className || ''}`}
      data-type={type} // optional if you want to pass the type prop for tracking
      onClick={() => {
        // optional tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Book a Valuation',
          formType: 'form-property-valuation',
          formId: 'form-property-valuation',
          formName: 'Book a Valuation',
          formLabel: 'Book a Valuation',
        });
      }}
    >
      {children}
    </Link>
  );
}